/*
  HELITE: keeps keyboard and agent focus out of content that is hidden from screen readers.

  The product carousels (Horizon slideshow) and the announcement bar mark off-screen items
  aria-hidden="true", but the links inside them could still be tabbed to. That breaks the
  accessibility tree (Lighthouse "[aria-hidden] elements contain focusable descendants" and the
  Agentic Browsing check). This gives those links tabindex="-1" while their item is hidden and
  restores them when it is shown again. Mouse and touch clicks are not affected.

  Kept as a separate file (loaded from layout/theme.liquid) so Horizon updates to slideshow.js
  do not remove it.
*/
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex], [contenteditable="true"]';
  var MARK = 'data-hidden-tabindex';

  function hide(root) {
    root.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (!el.hasAttribute(MARK)) {
        el.setAttribute(MARK, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function show(root) {
    root.querySelectorAll('[' + MARK + ']').forEach(function (el) {
      // Leave it alone if something further up is still hidden (e.g. a nested carousel slide)
      if (el.parentElement && el.parentElement.closest('[aria-hidden="true"]')) return;
      var original = el.getAttribute(MARK);
      el.removeAttribute(MARK);
      if (original === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', original);
      }
    });
  }

  function sync(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      hide(el);
    } else {
      show(el);
    }
  }

  function init() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(hide);

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          if (record.target.nodeType === 1) sync(record.target);
          return;
        }
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.getAttribute('aria-hidden') === 'true') hide(node);
          node.querySelectorAll('[aria-hidden="true"]').forEach(hide);
        });
      });
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
